import { BcitiTranslationsObject } from 'src/app/app.model';

export interface PermitDepartmentManager {
    _id: string;
    firstName: string;
    lastName: string;
    email: string;
}

export interface PermitDepartment {
    _id: string;
    name: BcitiTranslationsObject;
    description?: BcitiTranslationsObject;
    organisation: string;
    managers: (string | PermitDepartmentManager)[];
    isActive: boolean;
    order: number;
    externalId?: string;
    createdAt?: Date;
    updatedAt?: Date;
}

export interface CreatePermitDepartmentPayload {
    name: BcitiTranslationsObject;
    description?: BcitiTranslationsObject;
    managers?: (string | PermitDepartmentManager)[];
    order?: number;
    isActive?: boolean;
}

export type UpdatePermitDepartmentPayload = Partial<CreatePermitDepartmentPayload>;

export interface GetPermitDepartmentsParams {
    search?: string;
    includeInactive?: boolean;
}

export function permitDepartmentName(name: BcitiTranslationsObject | string | undefined, lang: string): string {
    if (!name) return '';
    if (typeof name === 'string') return name;
    return name[lang] || name.fr || name.en || '';
}

const ERROR_KEY_MAP: { [code: string]: string } = {
    'permit-department.has-active-types': 'permit.config.departments.error_has_active_types',
    'permit-department.not-found': 'permit.config.departments.error_not_found',
    'permit-department.inactive': 'permit.config.departments.error_inactive',
};

export function permitDepartmentErrorKey(err: any, fallback = 'permit.config.common.error'): string {
    const body = err?.error;
    const candidates: string[] = [];
    if (typeof body?.code === 'string') candidates.push(body.code);
    if (typeof body?.message === 'string') candidates.push(body.message);
    if (Array.isArray(body?.messages)) {
        candidates.push(...body.messages.filter((m: unknown) => typeof m === 'string'));
    }
    const match = candidates.find((c) => ERROR_KEY_MAP[c]);
    return match ? ERROR_KEY_MAP[match] : fallback;
}
